import React, { useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import * as FaIcons from "react-icons/fa";
import { SidebarDataAdmin } from "./SidebarDataAdmin";
import { SidebarDirector } from "./SidebarDirector";
import { SidebarDataInstitucion } from "./SidebarDataInstitucion";
import { getSidebarDataEvaluador } from "./SidebarDataEvaluador";
import { SidebarDataGestor } from "./SidebarDataGestor";
import SubMenu from "./SubMenu";
import { IconContext } from "react-icons/lib";
import logo from "../img/ICONTEC-LOGO-ORIGINAL-INV.png";
import Cookies from "universal-cookie";
import { SidebarJunta } from "./SidebarDataJunta";

const Nav = styled.div`
  background: linear-gradient(90deg, #0085ca, #00c6ff);
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  width: 100%;
  padding: 0 2rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 10000;
`;

const NavIcon = styled(Link)`
  font-size: 2rem;
  color: #fff;
  display: flex;
  align-items: center;
  cursor: pointer;

  &:hover {
    transform: scale(1.2);
    color: #ffe600;
  }
`;

const SidebarNav = styled.nav`
  background: linear-gradient(180deg, #0085ca, #005f99);
  width: 270px;
  height: calc(100vh - 80px);
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 80px;
  left: ${({ $sidebar }) => ($sidebar ? "0" : "-100%")};
  transition: left 350ms ease-in-out;
  z-index: 9999;
  overflow-y: auto;
`;

const SidebarWrap = styled.div`
  width: 100%;
  margin-top: 0.5rem;
`;

const NavImage = styled.img`
  width: 70px;
`;

const Sidebar = () => {
  const [sidebar, setSidebar] = useState(false);
  const cookies = new Cookies();

  const tipoUsuario = cookies.get("tipo_Usuario");

  const toggleSidebar = () => {
    setSidebar((prev) => !prev);
  };

  // 🔥 FUNCIÓN PRINCIPAL (100% SEGURA)
  const getSidebarData = () => {
    try {
      switch (Number(tipoUsuario)) {
        case 1:
          return SidebarDataAdmin();
        case 2:
          return SidebarDataInstitucion();
        case 3:
          return getSidebarDataEvaluador();
        case 4:
          return SidebarJunta();
        case 5:
          return SidebarDataGestor();
        case 6:
          return SidebarDirector();
        default:
          return SidebarDataAdmin();
      }
    } catch (error) {
      console.error("Error obteniendo sidebar:", error);
      return [];
    }
  };

  // 🛡️ BLINDAJE TOTAL
  const data = getSidebarData();
  const sidebarData = Array.isArray(data) ? data : [];

  return (
    <IconContext.Provider value={{ color: "#fff" }}>
      <>
        <Nav>
          <NavIcon to="#">
            <FaIcons.FaBars onClick={toggleSidebar} />
          </NavIcon>

          <h5 style={{ color: "#fff", margin: 0 }}>
            SISTEMA ÚNICO DE ACREDITACIÓN
          </h5>

          <NavImage src={logo} alt="Logo" />
        </Nav>

        <SidebarNav $sidebar={sidebar}>
          <SidebarWrap>
            {sidebarData.length > 0 ? (
              sidebarData.map((item, index) => (
                <SubMenu item={item} key={index} />
              ))
            ) : (
              <p style={{ color: "#fff", padding: "10px" }}>
                Sin menú disponible
              </p>
            )}
          </SidebarWrap>
        </SidebarNav>
      </>
    </IconContext.Provider>
  );
};

export default Sidebar;
